import type { EditorInput } from "./types";
import type {
  NodeOption,
  OutputOption,
} from "@/components/SpotflowV2/Sidebar/variableOptions";

function pickerGroupKey(input: EditorInput): string {
  return input.sourceNodeId ?? input.sourceName ?? "Inputs";
}

export function inputsToNodeOptions(inputs: EditorInput[]): NodeOption[] {
  const groups = new Map<string, EditorInput[]>();
  for (const input of inputs) {
    // The picker offers only what the text can take; an incompatible chip
    // already in the text stays in `inputs` so it still resolves (and warns).
    if (input.compatibility === "incompatible") continue;
    const key = pickerGroupKey(input);
    const bucket = groups.get(key) ?? [];
    bucket.push(input);
    groups.set(key, bucket);
  }
  return Array.from(groups.entries()).map(([groupKey, items]) => {
    const head = items[0];
    const outputs: OutputOption[] = items.map((input) => ({
      value: input.id,
      outputName: input.id,
      outputLabel: input.name,
      outputOriginalLabel: input.name,
      dataType: input.dataType,
      isList: input.isList,
      listDepth: input.isList ? 1 : 0,
      compatible: true,
      compatibility: input.compatibility ?? "ok",
      scope: input.scope,
    }));
    return {
      nodeId: groupKey,
      nodeName: head.sourceName ?? groupKey,
      nodeColor: head.sourceColor ?? "#e0e7ff",
      nodeImage: head.sourceImage,
      nodeIconName: head.sourceIconName,
      outputs,
      hasCompatible: true,
    };
  });
}
